// "Export to Excel" for any screen: sends the rows the screen shows to the server
// (POST /api/export/xlsx, server/routes/export.js), which builds the workbook,
// and saves the file it returns.
//
//   exportToExcel({
//     name: 'Entries', parts: [jobNo],        // -> Entries-<job>-<date-time>.xlsx
//     title: 'Entries — J1001',               // optional first line in the sheet
//     columns: [{ header: 'Date', key: 'PlanningDate', type: 'date' }, …],
//     rows,                                    // objects keyed by column key
//   })
// Column type: 'text' (default) | 'number' | 'money' | 'hours' | 'percent' | 'date'.
export async function exportToExcel({ name, parts, title, sheetName, columns, rows }) {
  const res = await fetch('/api/export/xlsx', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, parts, title, sheetName, columns, rows }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Export failed (${res.status})`);
  }
  const disposition = res.headers.get('Content-Disposition') || '';
  const match = /filename="([^"]+)"/.exec(disposition);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = match ? match[1] : `${name || 'Export'}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
